import React, { startTransition, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { getImageUrl, Logout } from "../common/Funcation";
import {
  styleObjectGetBG,
  styleObjectGetColor,
  styleObjectGetActiveMenuBG,
  styleObjectGetMenuColor,
  getTheme,
  styleObjectGetAdminHeader,
  styleObjectGetAdminNavBG,
  styleObjectGetAdminNavColor,
  styleObjectGetAdminNavActive,
  styleObjectGetReportDropdown,
  getAdminHeaderValue,
  getAdminNavValue,
} from "../common/StyleSeter";
import logoutArrow from "../assets/images/logout-arrow.svg";
import { Helmet } from "react-helmet";
import NewsLine from "./NewsLine";
import { sendEvent } from "../service";
import { getApi, postApi } from "../service";
import { ADMIN_API } from "../common/common";
import {
  canSeeCommonSetting,
  canSeeResult,
  checkSettingOption,
  isAdminSettingRole,
  isMySettingRole,
} from "../common/settingsAccess";

type LiveUsers = { total: number; players: number; admins: number };

function readLiveUsers(source: any): LiveUsers | null {
  if (!source || typeof source !== "object") return null;
  const players = source.onlinePlayer ?? source.onlinePlayers;
  const admins = source.onlineAdmin ?? source.onlineAdmins;
  if (typeof source.onlineTotal === "number") {
    return {
      total: source.onlineTotal,
      players: typeof players === "number" ? players : 0,
      admins: typeof admins === "number" ? admins : 0,
    };
  }
  const fallback = source.onlinePlayer ?? source.onlineUser;
  if (typeof fallback !== "number") return null;
  return {
    total: fallback,
    players: typeof players === "number" ? players : fallback,
    admins: typeof admins === "number" ? admins : 0,
  };
}

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const HeaderData = useSelector((e: any) => e.Header);
  const balanceData = useSelector((e: any) => e.balance);
  const DD = useSelector((e: any) => e.domainDetails);
  const [domainDetails, setDomainDetails] = useState(DD);
  const [balance, setBalance] = useState(balanceData);
  const [headerOptions, setHeaderOptions] = useState(HeaderData);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [hoveredMenu, setHoveredMenu] = useState<string | null>(null);
  const [openMenu, setOpenMenu] = useState<string | null>(null);
  const usersCount = useSelector((e: any) => e.home_userCount);
  const [liveUsers, setLiveUsers] = useState<LiveUsers>(
    () => readLiveUsers(usersCount) || { total: 0, players: 0, admins: 0 }
  );
  console.log("headerOptions today :: ", headerOptions);
  // console.log("agent_level:: ", headerOptions.name);

  useEffect(() => {
    setBalance(balance);
    return () => {};
  }, [balanceData]);

  useEffect(() => {
    setHeaderOptions(HeaderData);
    return () => {};
  }, [HeaderData]);

  useEffect(() => {
    setDomainDetails(DD);
    return () => {};
  }, [DD]);

  useEffect(() => {
    const next = readLiveUsers(usersCount);
    if (next) setLiveUsers(next);
  }, [usersCount]);

  useEffect(() => {
    if (headerOptions?.name !== "O") return;
    let cancelled = false;
    const fetchOnline = async () => {
      try {
        const res = await getApi({ api: ADMIN_API.ANALYTICS_ONLINE });
        const next = readLiveUsers(res?.data?.data);
        if (!cancelled && next) setLiveUsers(next);
      } catch (_) {}
    };
    fetchOnline();
    const timer = setInterval(fetchOnline, 10000);
    return () => {
      cancelled = true;
      clearInterval(timer);
    };
  }, [headerOptions?.name]);

  useEffect(() => {
    return () => {};
  }, [window.location.pathname]);

  const checkSelected = (link: string) => {
    if (location.pathname.includes(link)) return true;
    else return false;
  };

  const checkSelectedMulti = (links: any) => {
    if (links.includes(location.pathname)) return true;
    else return false;
  };
  const agentLevel = HeaderData?.name;
  // console.log({ headerOptions });
  const headerOption = useMemo(() => {
    const headerOptions = HeaderData || {};
    return [
      {
        name: "Downline List",
        hasAccess: headerOptions.downline_list,
        link: "/",
        subOption: [],
      },
      {
        name: "My Account",
        selected: checkSelected("/profile"),
        hasAccess: headerOptions.my_account,
        link: "/profile",
        subOption: [],
      },
      {
        name: "My Report",
        selected: checkSelectedMulti([
          "/loss/down-line",
          "/loss/market",
          "/account/statement",
          "report/DW",
          "/showProviderPL",
        ]),
        hasAccess: true,
        link: "",
        subOption: [
          {
            name: "Profit/Loss Report by Market",
            hasAccess: headerOptions.market_report,
            link: "/loss/market",
          },
          {
            name: "Profit/Loss Downline",
            hasAccess: headerOptions.downline_report,
            link: "/loss/down-line",
          },
          // {
          //   name: "Account Statement",
          //   hasAccess: headerOptions.account_statement,
          //   link: "/account/statement",
          // },
          // { name: "Deposit and withdraw", hasAccess: 1, link: "/report/DW" },
          { name: "Match Profit Loss", hasAccess: 1, link: "/loss/match" },
          {
            name: "Casino P/L Downline Monthly",
            hasAccess:
              headerOptions.casinoReport || headerOptions?.casinoReport !== 0,
            link: "/loss/casino",
          },
          {
            name: "SABA P/L Downline Monthly",
            hasAccess: 1,
            link: "/loss/saba",
          },
          { name: "Provider PL", hasAccess: 1, link: "/showProviderPL" },
        ],
      },
      {
        name: "BetList",
        hasAccess: headerOptions.bet_list,
        link: "/betList",
        subOption: [],
      },
      {
        name: "BetListLive",
        hasAccess: headerOptions.bet_list_live,
        link: "/bet-live",
        subOption: [],
      },
      {
        name: "Risk Management",
        hasAccess: headerOptions.risk_management,
        link: "/risk-management",
        subOption: [],
      },
      // {
      //   name: 'Risk Management', selected: checkSelectedMulti(['/Ariskmanagement']), hasAccess: headerOptions.risk_management, link: '', subOption: [
      //     { name: 'Sports Risk Management', hasAccess: headerOptions.downline_report, link: '/Ariskmanagement' },
      //     { name: 'Casino Risk Management', hasAccess: headerOptions.market_report, link: '/ACasRiskMgmt' },
      //   ]
      // },
      // { name: 'Casino live', hasAccess: headerOptions.casino_manage, link: '', subOption: [], },
      {
        name: "Banking",
        hasAccess: headerOptions.agent_banking || headerOptions.player_banking,
        link: headerOptions.agent_banking
          ? "/agent/banking"
          : headerOptions.player_banking
            ? "/player/banking"
            : "",
        subOption: [],
      },
      // {
      //   name: 'Banking', selected: checkSelectedMulti(['/master/banking', '/player/banking', '/agent/banking', '/bankingMethod']), hasAccess: true, link: '', subOption: [
      //     { name: 'Master Banking', hasAccess: headerOptions.add_balance, link: '/master/banking', },
      //     { name: 'Player Banking', hasAccess: headerOptions.player_banking, link: '/player/banking', },
      //     { name: 'Agent Banking', hasAccess: headerOptions.agent_banking, link: '/agent/banking', },
      //     { name: 'Banking Method', hasAccess: (headerOptions?.bankingMethod || headerOptions?.bankingMethod === undefined), link: '/bankingMethod', }],
      // },

      {
        name: "Banking Method",
        hasAccess:
          headerOptions?.bankingMethod ||
          headerOptions?.bankingMethod === undefined,
        link: "/bankingMethod",
        subOption: [],
      },
      {
        name: "Block Market",
        hasAccess: headerOptions.marketBlock,
        link: "/block-market",
        subOption: [],
      },
      {
        name: "Add Match",
        hasAccess: headerOptions.sports_leage || headerOptions.site_match,
        link: "/add-match",
        subOption: [],
      },
      {
        name: "Sport Settings",
        hasAccess:
          headerOptions.name === "SUO" ||
          headerOptions.name === "WL" ||
          isMySettingRole(headerOptions.name)
            ? canSeeCommonSetting(headerOptions) &&
              (headerOptions.sportSettings ?? 1)
            : headerOptions.sportSettings ?? true,
        link: "/sport-settings",
        subOption: [],
      },
      // { name: 'Sport League', hasAccess: headerOptions.sports_leage, link: '/sport-league', subOption: [], },
      {
        name: isAdminSettingRole(agentLevel) ? "Admin Setting" : "My settings",
        hasAccess: checkSettingOption(headerOptions),
        link: "/AdminSetting",
        subOption: [],
      },
      // {
      //   name: "Casino",
      //   hasAccess: headerOptions.name === "O",
      //   link: "/casino",
      //   subOption: [],
      // },
      {
        name: "Result",
        hasAccess: canSeeResult(headerOptions) ? 1 : 0,
        link: "/AsetResult",
        subOption: [],
      },
      {
        name: "Old Res.",
        hasAccess: headerOptions.match_history,
        link: "/Achecksportwiseresult",
        subOption: [],
      },
      {
        name: "deposit-req",
        hasAccess:
          headerOptions?.onlinePaymentWithdrawals ||
          headerOptions?.onlinePaymentDeposite ||
          headerOptions?.onlinePaymentWithdrawals !== 0 ||
          headerOptions?.onlinePaymentDeposite !== 0,
        link: "/Atransactionlist",
        subOption: [],
      },
      {
        name: "withdrawl-req",
        hasAccess:
          headerOptions?.onlinePaymentWithdrawals ||
          headerOptions?.onlinePaymentDeposite ||
          headerOptions?.onlinePaymentWithdrawals !== 0 ||
          headerOptions?.onlinePaymentDeposite !== 0,
        link: "/AtransactionlistWithdrawl",
        subOption: [],
      },
      // {
      // name: 'Setting', hasAccess: checkSettingOption(), selected: checkSelectedMulti(['/main-market', '/winner/cricket/history', '/session/cricket/declare', '/session/cricket/history', '/cricket/premium/declare', '/cricket/premium/history', '/website', '/casino', '/dashboard-images', '/banner', '/add-website', 'add-dashboard', '/add-banner']), link: '', subOption: [
      // { name: 'Sports Main Market', hasAccess: headerOptions.sports_main_market, link: '/main-market', },
      // { name: 'Match History', hasAccess: headerOptions.match_history, link: '/winner/cricket/history', },
      // { name: 'Manage Fancy', hasAccess: headerOptions.manage_fancy, link: '/session/cricket/declare', },
      // { name: 'Fancy History', hasAccess: headerOptions.fancy_history, link: '/session/cricket/history', },
      // { name: 'Manage Premium', hasAccess: headerOptions.manage_premium, link: '/cricket/premium/declare', },
      // { name: 'Manage Premium History', hasAccess: headerOptions.premium_history, link: '/cricket/premium/history', },
      // { name: 'Website Setting', hasAccess: headerOptions.manage_website, link: '/website', },
      // { name: 'Manage Casino', hasAccess: headerOptions.casino_manage, link: '/casino', },
      // { name: 'Dashboard Images', hasAccess: headerOptions.manage_dashboard_images, link: '/dashboard-images', },
      // { name: 'Banner', hasAccess: headerOptions.banner, link: '/banner', },
      // ],
      // },
      {
        name: "Online Payment",
        hasAccess:
          headerOptions?.onlinePaymentWithdrawals ||
          headerOptions?.onlinePaymentDeposite ||
          headerOptions?.onlinePaymentWithdrawals !== 0 ||
          headerOptions?.onlinePaymentDeposite !== 0,
        selected: checkSelectedMulti([
          "/payment/deposit",
          "/payment/withdraw",
          "/payment/sbkash",
        ]),
        subOption: [
          {
            name: "Deposit",
            hasAccess:
              headerOptions?.onlinePaymentDeposite ||
              headerOptions?.onlinePaymentDeposite !== 0,
            link: "/payment/deposit",
          },
          {
            name: "Withdraw",
            hasAccess:
              headerOptions?.onlinePaymentWithdrawals ||
              headerOptions?.onlinePaymentWithdrawals !== 0,
            link: "/payment/withdraw",
          },
        ],
      },
      // {
      //   name: "SBKasH",
      //   hasAccess: headerOptions?.name === "O",
      //   link: "/payment/sbkash",
      //   subOption: [],
      // },
      {
        name: "Privileges",
        hasAccess: headerOptions.privileges,
        link: "/Privileges",
        subOption: [],
      },
      {
        name: "System",
        hasAccess: headerOptions?.name === "O",
        link: "",
        subOption: [
          { name: "Ops Center", hasAccess: true, link: "/ops" },
          { name: "Exposer Calc", hasAccess: true, link: "/exposure-calc" },
          { name: "Update User", hasAccess: true, link: "/update-user" },
          { name: "Analytics", hasAccess: true, link: "/analytics" },
        ],
      },
    ];
  }, [HeaderData, location.pathname]);

  const HandleNavigation = (path: string) => {
    if (path !== "") {
      // Check if the current pathname matches the destination
      if (location.pathname === path) {
        navigate(0); // Triggers a React Router re-validation/refresh
      } else {
        startTransition(() => {
          navigate(path);
        });
      }
    }
  };

  const HandleLogOut = async (e: any) => {
    e.preventDefault();
    document.body.classList.add("login_screen");
    document.documentElement.classList.add("login_screen");
    await Logout(e);
    dispatch({ type: "LOGOUT" });
  };

  const handleRefresh = async () => {
    setIsRefreshing(true);
    try {
      // Refresh role/permissions
      const roleData = {
        api: ADMIN_API.GET_ROLE,
        value: {},
      };
      await getApi(roleData).then(function (response: any) {
        dispatch({ type: "HEADER_DETAILS", payload: response.data.data });
      });

      // Refresh domain/site details
      const siteData = {
        api: ADMIN_API.SETTING.WEBSITE.GET_SITE,
        value: {
          domain: window.location.hostname,
        },
      };
      await postApi(siteData).then(function (response: any) {
        dispatch({ type: "DOMAIN_DETAILS", payload: response.data.data });
      });

      // Refresh user count/balance
      sendEvent("GET_USER_COUNT", {});
    } catch (error) {
      console.error("Error refreshing data:", error);
    } finally {
      setTimeout(() => {
        setIsRefreshing(false);
      }, 1000);
    }
  };

  console.log({ headerOption });
  console.log({
    color: styleObjectGetActiveMenuBG(domainDetails?.colorSchema),
    domainColor: domainDetails?.colorSchema,
  });

  console.log({
    hoveredMenu: styleObjectGetMenuColor(domainDetails?.colorSchema),
  });

  const adminHeaderValue = getAdminHeaderValue(
    domainDetails?.adminHeaderSchema,
  );
  const adminNavValue = getAdminNavValue(domainDetails?.adminNavSchema);
  const hasCustomAdminHeader = !!adminHeaderValue;
  const hasCustomAdminNav = !!adminNavValue;
  const adminHeaderStyle = styleObjectGetAdminHeader(
    domainDetails?.adminHeaderSchema,
    domainDetails?.adminHeaderTextColor,
  );
  const navBgStyle = styleObjectGetAdminNavBG(
    domainDetails?.adminNavSchema,
    domainDetails?.colorSchema,
  );
  const navColorStyle = styleObjectGetAdminNavColor(
    domainDetails?.adminNavSchema,
    domainDetails?.adminNavTextColor,
    domainDetails?.colorSchema,
  );
  const navActiveStyle = styleObjectGetAdminNavActive(
    domainDetails?.adminNavSchema,
    domainDetails?.adminNavTextColor,
    domainDetails?.colorSchema,
  );
  const navHoverBg = hasCustomAdminNav
    ? navActiveStyle?.background || "rgba(255, 255, 255, 0.22)"
    : getTheme(domainDetails?.colorSchema)?.activeMenuColor ||
      getTheme(domainDetails?.colorSchema)?.backgroundColor ||
      "rgba(255, 255, 255, 0.4)";
  const reportDropdownStyle = styleObjectGetReportDropdown(
    domainDetails?.adminNavSchema,
    domainDetails?.colorSchema,
  );
  const grayDropdownStyle = {
    background: "#eaeaea",
    color: "#000",
    hoverBackground: "#f5f5f5",
  };

  // Count visible menu items
  const visibleMenuCount = headerOption.filter((item) => item.hasAccess).length;
  console.log("Visible menu count:", visibleMenuCount);

  // Save menu count to Redux
  useEffect(() => {
    dispatch({ type: "SET_MENU_COUNT", payload: visibleMenuCount });
  }, [visibleMenuCount, dispatch]);

  const shouldStackLogout = visibleMenuCount >= 15;
  return (
    <>
      <Helmet>
        <title>{domainDetails?.title}</title>
      </Helmet>
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
          ${
            hasCustomAdminNav
              ? `
          .top .menu-wrap a.menu-drop:after,
          .top .menu-wrap a.menu-drop.select:after {
            border-top-color: ${navColorStyle?.color || "#fff"};
          }
          `
              : ""
          }
        `}
      </style>
      <div
        className={`top${hasCustomAdminHeader ? " admin-header-custom" : ""}`}
        style={adminHeaderStyle}
      >
        <div className="header">
          <div className="header_wrp_l">
            <div className="header_wrp_l_logo">
              <h1>
                <img
                  src={
                    domainDetails?.adminLogo && domainDetails?.adminLogo !== ""
                      ? getImageUrl(domainDetails?.adminLogo)
                      : getImageUrl(domainDetails?.logo)
                  }
                  alt="logo"
                  onClick={() => (window.location.href = "/")}
                />
              </h1>
            </div>
            <div className="header_wrp_r">
              <ul className="account-wrap">
                {/* {
                  (headerOptions?.onlinePaymentWithdrawals || headerOptions?.onlinePaymentDeposite || headerOptions?.onlinePaymentWithdrawals !== 0 || headerOptions?.onlinePaymentDeposite !== 0) && <> 
                  
                  <li className='header-count cursor-pointer' style={{cursor:"pointer"}} onClick={()=> HandleNavigation('/Atransactionlist')}>
                    <img src="../../images/download.png" style={{width:"23px", height:"23px"}} alt=''/>
                    <span>{headerOptions?.depositeCount}</span>
                  </li>
                  <li className='header-count cursor-pointer' style={{cursor:"pointer"}} onClick={()=> HandleNavigation('/AtransactionlistWithdrawl')}>
                    <img src="../../images/download-up.png" style={{width:"23px", height:"23px"}} alt=''/>
                    <span>{headerOptions?.withdrawaCount}</span>
                  </li>
                </>
                } */}
                <li>
                  <span style={{ background: "#000", color: "#fff" }}>
                    {headerOptions.name}
                  </span>
                  <strong
                    className="login-user-name"
                    style={{
                      color: domainDetails?.adminHeaderTextColor || "#000",
                    }}
                  >
                    {headerOptions.user_name}
                  </strong>
                </li>
                <li className="main-wallet no-multi">
                  <a className="a-wallet">
                    <ul>
                      <li>
                        <span style={{ background: "#000", color: "#fff" }}>
                          Main
                        </span>
                        <strong
                          className="login-user-balance"
                          id="mainBalance"
                          style={{
                            color:
                              domainDetails?.adminHeaderTextColor || "#000",
                          }}
                        >
                          {isRefreshing ? (
                            <div
                              style={{
                                width: "16px",
                                height: "16px",
                                border: "2px solid #f3f3f3",
                                borderTop: "2px solid #3498db",
                                borderRadius: "50%",
                                animation: "spin 1s linear infinite",
                              }}
                            ></div>
                          ) : (
                            <>
                              {domainDetails?.currency
                                ? domainDetails?.currency
                                : "PTH"}{" "}
                              {Number(balanceData || 0).toFixed(2)}
                            </>
                          )}
                        </strong>
                      </li>
                    </ul>
                  </a>

                  <a
                    id="topRefresh"
                    onClick={handleRefresh}
                    className="a-refresh"
                    style={{ background: "#000", color: "#fff" }}
                  >
                    <svg
                      style={{ color: "#fff" }}
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 512 512"
                      width="20"
                      height="20"
                    >
                      <path
                        fill="currentColor"
                        d="M411.826,289.391c0,86.061-69.766,155.826-155.826,155.826s-155.826-69.766-155.826-155.826S169.939,133.565,256,133.565v66.783l100.174-100.174L256,0v66.783c-122.943,0-222.609,99.665-222.609,222.609S133.057,512,256,512s222.609-99.665,222.609-222.609H411.826z"
                      />
                    </svg>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="menu_part menu-wrap" style={navBgStyle}>
          <div className="main_wrap">
            <ul className="menu">
              {headerOption.map((item, i) => {
                if (!item.hasAccess) return false;
                console.log({ item });
                const followReportNav =
                  item.name === "My Report" && reportDropdownStyle.followNav;
                const dropdownStyle = followReportNav
                  ? reportDropdownStyle
                  : grayDropdownStyle;
                const paintDropdown =
                  (background: string) => (el: HTMLElement | null) => {
                    if (!el) return;
                    if (!followReportNav) {
                      el.style.removeProperty("background");
                      el.style.removeProperty("color");
                      el.style.background = background;
                      el.style.color = dropdownStyle.color;
                      return;
                    }
                    el.style.setProperty("background", background, "important");
                    el.style.setProperty(
                      "color",
                      dropdownStyle.color,
                      "important",
                    );
                  };
                return (
                  <li
                    key={i}
                    onMouseEnter={() =>
                      item.subOption.length > 0 && setOpenMenu(item.name)
                    }
                    onMouseLeave={() =>
                      item.subOption.length > 0 && setOpenMenu(null)
                    }
                  >
                    <a
                      style={{
                        ...navColorStyle,
                        fontSize: "12px",
                        ...(window.location.pathname === item.link ||
                        item.selected ||
                        hoveredMenu === item.link ||
                        hoveredMenu === item.name
                          ? {
                              ...navActiveStyle,
                              "--menu-hover-bg": navHoverBg,
                            }
                          : {}),
                      }}
                      className={`${item.subOption.length > 0 ? "menu-drop " : ""} ${window.location.pathname === item.link || item.selected ? "selected" : ""}`}
                      href={item.link || "#"}
                      onClick={(e) => {
                        if (item.subOption.length > 0 || !item.link) {
                          e.preventDefault();
                          if (item.subOption.length > 0) setOpenMenu(item.name);
                          return;
                        }
                        if (
                          e.metaKey ||
                          e.ctrlKey ||
                          e.shiftKey ||
                          e.altKey ||
                          e.button !== 0
                        ) {
                          return;
                        }
                        e.preventDefault();
                        HandleNavigation(item.link);
                      }}
                      onMouseEnter={() =>
                        setHoveredMenu(item.link || item.name || null)
                      }
                      onMouseLeave={() => setHoveredMenu(null)}
                    >
                      {item.name}
                      {item.name === "System" ? (
                        <span
                          className="menu-active-badge"
                          title="Players and admins on the site right now"
                        >
                          {liveUsers.total}
                        </span>
                      ) : (
                        ""
                      )}
                      {item.name === "Casino live" ? (
                        <img
                          style={{ width: "20px" }}
                          src="/images/card-game.svg"
                        />
                      ) : (
                        ""
                      )}
                    </a>
                    {item.subOption.length > 0 ? (
                      <>
                        <ul
                          className="submenudiv"
                          ref={paintDropdown(dropdownStyle.background)}
                          style={{
                            display: openMenu === item.name ? "block" : "none",
                            background: dropdownStyle.background,
                            color: dropdownStyle.color,
                            borderRight: "1px solid #000",
                            borderBottom: "1px solid #000",
                          }}
                        >
                          {item.name === "System"
                            ? [
                                ["Online", liveUsers.total, true],
                                ["Players", liveUsers.players, false],
                                ["Admins", liveUsers.admins, false],
                              ].map(([label, count, showDot]) => (
                                <li
                                  key={String(label)}
                                  style={{
                                    background: grayDropdownStyle.background,
                                    color: grayDropdownStyle.color,
                                  }}
                                  className="system-active-users"
                                >
                                  <span
                                    className="system-active-users-label"
                                    style={{ color: grayDropdownStyle.color }}
                                  >
                                    {showDot ? (
                                      <span className="system-active-dot" />
                                    ) : null}
                                    {label}
                                  </span>
                                  <strong
                                    className="system-active-users-count"
                                    style={{ color: "#000" }}
                                  >
                                    {count}
                                  </strong>
                                </li>
                              ))
                            : null}
                          {item.subOption.map((subItem, i) => {
                            if (!subItem.hasAccess) return false;
                            const subHovered =
                              window.location.pathname === subItem.link ||
                              hoveredMenu === `${item.link}-${subItem.link}`;
                            const rowBackground = subHovered
                              ? dropdownStyle.hoverBackground
                              : dropdownStyle.background.includes("gradient")
                                ? "transparent"
                                : dropdownStyle.background;
                            return (
                              <li
                                ref={paintDropdown(rowBackground)}
                                style={{
                                  background: rowBackground,
                                  color: dropdownStyle.color,
                                  borderBottom:
                                    i < item.subOption.length - 1
                                      ? "1px solid #000"
                                      : "0",
                                }}
                                className={`selected ${window.location.pathname === subItem.link ? "active" : ""}`}
                                key={i}
                              >
                                <a
                                  className="sbmenu"
                                  ref={paintDropdown(rowBackground)}
                                  style={{
                                    color: dropdownStyle.color,
                                    fontSize: "12px",
                                    background: rowBackground,
                                  }}
                                  onClick={(e) => {
                                    e.preventDefault();
                                    setOpenMenu(null);
                                    HandleNavigation(subItem.link);
                                  }}
                                  href={subItem.link}
                                  onMouseEnter={() =>
                                    setHoveredMenu(
                                      `${item.link}-${subItem.link}`,
                                    )
                                  }
                                  onMouseLeave={() => setHoveredMenu(null)}
                                >
                                  {subItem.name}
                                </a>
                              </li>
                            );
                          })}
                        </ul>
                      </>
                    ) : (
                      ""
                    )}
                  </li>
                );
              })}

              {shouldStackLogout ? (
                <li
                  className="logout"
                  onClick={(e) => HandleLogOut(e)}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-end",
                    borderLeft: "none",
                  }}
                >
                  <a
                    style={{
                      ...navColorStyle,
                      borderLeft: "1px solid rgb(102 102 102 / 62%)",
                      fontSize: "12px",
                      ...(window.location.pathname === "/login" ||
                      hoveredMenu === "logout"
                        ? { ...navActiveStyle, "--menu-hover-bg": navHoverBg }
                        : {}),
                    }}
                    id="logout"
                    href="/login"
                    onMouseEnter={() => setHoveredMenu("logout")}
                    onMouseLeave={() => setHoveredMenu(null)}
                  >
                    Logout
                    <svg
                      style={{ marginLeft: "5px" }}
                      width="12"
                      height="12"
                      viewBox="0 0 52 52"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill="#000000"
                        d="M21,48.5v-3c0-0.8-0.7-1.5-1.5-1.5h-10C8.7,44,8,43.3,8,42.5v-33C8,8.7,8.7,8,9.5,8h10C20.3,8,21,7.3,21,6.5v-3C21,2.7,20.3,2,19.5,2H6C3.8,2,2,3.8,2,6v40c0,2.2,1.8,4,4,4h13.5C20.3,50,21,49.3,21,48.5z"
                      />
                      <path
                        fill="#000000"
                        d="M49.6,27c0.6-0.6,0.6-1.5,0-2.1L36.1,11.4c-0.6-0.6-1.5-0.6-2.1,0l-2.1,2.1c-0.6,0.6-0.6,1.5,0,2.1l5.6,5.6c0.6,0.6,0.2,1.7-0.7,1.7H15.5c-0.8,0-1.5,0.6-1.5,1.4v3c0,0.8,0.7,1.6,1.5,1.6h21.2c0.9,0,1.3,1.1,0.7,1.7l-5.6,5.6c-0.6,0.6-0.6,1.5,0,2.1l2.1,2.1c0.6,0.6,1.5,0.6,2.1,0L49.6,27z"
                      />
                    </svg>
                  </a>
                  <span
                    style={{
                      ...navColorStyle,
                      borderLeft: "none",
                      fontSize: "12px",
                    }}
                    className="time_zone"
                  >
                    GMT+6:00
                  </span>
                </li>
              ) : (
                <>
                  <li className="logout" onClick={(e) => HandleLogOut(e)}>
                    <a
                      style={{
                        ...navColorStyle,
                        fontSize: "12px",
                        ...(window.location.pathname === "/login" ||
                        hoveredMenu === "logout"
                          ? { ...navActiveStyle, "--menu-hover-bg": navHoverBg }
                          : {}),
                      }}
                      id="logout"
                      href="/login"
                      onMouseEnter={() => setHoveredMenu("logout")}
                      onMouseLeave={() => setHoveredMenu(null)}
                    >
                      Logout
                      <svg
                        style={{ marginLeft: "3px" }}
                        width="12"
                        height="12"
                        viewBox="0 0 52 52"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill="#000000"
                          d="M21,48.5v-3c0-0.8-0.7-1.5-1.5-1.5h-10C8.7,44,8,43.3,8,42.5v-33C8,8.7,8.7,8,9.5,8h10C20.3,8,21,7.3,21,6.5v-3C21,2.7,20.3,2,19.5,2H6C3.8,2,2,3.8,2,6v40c0,2.2,1.8,4,4,4h13.5C20.3,50,21,49.3,21,48.5z"
                        />
                        <path
                          fill="#000000"
                          d="M49.6,27c0.6-0.6,0.6-1.5,0-2.1L36.1,11.4c-0.6-0.6-1.5-0.6-2.1,0l-2.1,2.1c-0.6,0.6-0.6,1.5,0,2.1l5.6,5.6c0.6,0.6,0.2,1.7-0.7,1.7H15.5c-0.8,0-1.5,0.6-1.5,1.4v3c0,0.8,0.7,1.6,1.5,1.6h21.2c0.9,0,1.3,1.1,0.7,1.7l-5.6,5.6c-0.6,0.6-0.6,1.5,0,2.1l2.1,2.1c0.6,0.6,1.5,0.6,2.1,0L49.6,27z"
                        />
                      </svg>
                    </a>
                  </li>
                  <li
                    style={{
                      ...navColorStyle,
                      fontSize: "12px",
                    }}
                    className="time_zone"
                  >
                    <span></span> GMT+6:00
                  </li>
                </>
              )}
            </ul>
          </div>
        </div>
      </div>
      {/* <NewsLine /> */}
    </>
  );
};

export default Header;
